module.exports = __webpack_public_path__ + "static/media/girl1.b117fedf.jpeg";